/**
 * 도움창(PopupHelper)이 넣어준 값인지 표시/판별하는 모듈.
 *
 * ag-Grid의 colDef.onCellValueChanged 콜백에는 eventSource(`source`)가 전달되지 않아서
 * "사용자가 코드를 직접 입력한 것"과 "도움창이 값을 넣어준 것"을 구분할 수 없다.
 * 게다가 이 콜백은 cellValueChanged 리스너가 async(=setTimeout(0))로 등록되어 있어
 * setDataValue 이후 다음 매크로태스크에 실행된다. 따라서 동기 플래그로는 구분이 불가능하고,
 * 셀 단위 표시를 남겨두고 콜백이 그 표시를 소비(consume)하는 방식으로 판별한다.
 *
 * 순환참조를 피하기 위해 의존성 없는 별도 모듈로 둔다.
 * (SnColumnsCreate → SnGridPopup → SinglePopup → SnGrid → SnColumnsCreate)
 */
const pendingPopupValues = new Set<string>();

const markKey = (node: any, colId: string, value: any) =>
  `${node?.id ?? ""}|${colId}|${String(value ?? "")}`;

/** 도움창이 선택한 값을 행에 반영한다. source는 setDataValue의 eventSource(예: "noEvent"). */
export const setPopupValue = (
  node: any,
  colId: string,
  value: any,
  source?: string
) => {
  pendingPopupValues.add(markKey(node, colId, value));
  return node.setDataValue(colId, value, source);
};

/**
 * 이 셀 변경이 도움창에서 들어온 것인지 확인하고 표시를 소비한다.
 * true면 이미 확정된 값이므로 코드박스의 재조회/초기화 로직을 타면 안 된다.
 */
export const consumePopupValue = (node: any, colId: string, value: any) =>
  pendingPopupValues.delete(markKey(node, colId, value));

/** 값이 실제로 바뀌지 않아 콜백이 안 불린 경우 등 미소비 표시를 정리한다. */
export const clearPopupValueMarks = () => pendingPopupValues.clear();
